import { useEffect } from "react";

const reducedMotion = () => window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

// Animaciones de la landing:
// - --lp-scroll con los px scrolleados, para el parallax hecho en CSS. Se escribe solo en los
//   bloques con data-scroll que están en pantalla: escribirlo en el contenedor de toda la landing
//   obligaba a recalcular los estilos de toda la página en cada frame y bajaban los fps.
// - Los elementos con data-reveal reciben la clase lp-in cuando entran en pantalla.
const useLandingMotion = (rootRef) => {

    useEffect(() => {
        const root = rootRef.current;
        if (!root) return;

        const targets = root.querySelectorAll("[data-reveal]");

        if (reducedMotion() || !("IntersectionObserver" in window)) {
            targets.forEach(el => el.classList.add("lp-in"));
            return;
        }

        const visible = new Set();
        const writeScroll = (el) => el.style.setProperty("--lp-scroll", String(window.scrollY));

        let frame = null;
        const onScroll = () => {
            if (frame) return;
            frame = window.requestAnimationFrame(() => {
                visible.forEach(writeScroll);
                frame = null;
            });
        };

        const scopes = root.querySelectorAll("[data-scroll]");
        scopes.forEach(writeScroll);
        const scrollObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    visible.add(entry.target);
                    writeScroll(entry.target);
                } else {
                    visible.delete(entry.target);
                }
            });
        }, { rootMargin: "200px 0px" });
        scopes.forEach(el => scrollObserver.observe(el));
        window.addEventListener("scroll", onScroll, { passive: true });

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add("lp-in");
                    observer.unobserve(entry.target);
                }
            });
        }, { threshold: 0.15, rootMargin: "0px 0px -40px 0px" });
        targets.forEach(el => observer.observe(el));

        return () => {
            window.removeEventListener("scroll", onScroll);
            if (frame) window.cancelAnimationFrame(frame);
            observer.disconnect();
            scrollObserver.disconnect();
        };
    }, [rootRef]);
}

export default useLandingMotion
